import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import { constantes } from './app'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    title: '',
    price: '',
    promoPrice: '',
    promoDeadline: '',
    news: [],
    collabs: [],
    slides: [],
    partners: [],
    optinTitleByPartner: {
      [constantes.HostHortusBox]: 'Merci pour vos réponses.'
    },
    optinMsgByPartner: {
      [constantes.HostHortusBox]: 'Vous allez être redirigé(e) vers le paiement.'
    },
    livrableByPartner: {
      [constantes.HostHortusBox]: 'https://hortusbox.com/strapi/uploads/Hortus_Book_8c926f3abb.pdf'
    }
  },
  mutations: {
    setTitle (state, args) {
      state.title = args
      state.title = state.title.replace("@price@", state.price)
    },
  
    setPrice (state, args) {
      state.price = args
    },

    setOptInTitle (state, {partner, value}) { 
      state.optinTitleByPartner = {
        ...state.optinTitleByPartner,
        [partner]: value
      }
    },

    setOptInMsg (state, {partner, value}) {
      state.optinMsgByPartner = {
        ...state.optinMsgByPartner,
        [partner]: value
      }
    },

    setPromoPrice (state, args) {
      state.promoPrice = parseInt(args)
    },

    setPromoDeadline (state, args) {
      state.promoDeadline = args
    },

    setCollab (state, args) {
      state.collabs = args
    },

    setSlide (state, args) {
      state.slides = args
    },

    setPartner (state, args) {
      state.partners = args
    },

    setNews (state, args) {
      state.news = args
    },

    setLivrable (state, {partner, value}) {
      state.livrableByPartner = {
        ...state.livrableByPartner,
        [partner]: value
      }
    }

  },
  actions: {
    async getLandingPageConfig({commit}) {
      axios
      .get('https://strapi.hortusbox.com/app-configs?Type=landingpage')
      .then( ({data}) => {
        data.forEach(item => {
          switch(item.Key) {
            case 'Price': commit('setPrice', item.Value); break;
            case 'Title': commit('setTitle', item.Value); break;
            case 'PromoPrice': commit('setPromoPrice', item.Value); break;
            case 'PromoDeadline': commit('setPromoDeadline', item.Value); break;
            case 'optin:leroymerlin:title': commit('setOptInTitle', {partner: constantes.HostLeroyMerlin, value: item.Value}); break;
            case 'optin:leroymerlin:msg': commit('setOptInMsg', {partner: constantes.HostLeroyMerlin, value: item.Value}); break;
            case 'livrable:default': commit('setLivrable', {partner: constantes.HostHortusBox, value: item.Value}); break;
            case 'livrable:leroymerlin': commit('setLivrable', {partner: constantes.HostLeroyMerlin, value: item.Value}); break;
          }
        })
      })
      .catch( (err) => {
        console.log(err)
      })
    },
    async getCollab({commit}) {
      axios
      .get('https://strapi.hortusbox.com/hortus-members')
      .then( ({data}) => {
        commit('setCollab', data.map((item) => {
          return {
            name: item.Name,
            title: item.Title,
            avatar: "/gimc/strapi/"+item.Avatar.url
          }
        }))
      })
      .catch( (err) => {
        console.log(err)
      })
    },
    async getNews({commit}) {
      axios
      .get('https://strapi.hortusbox.com/web-news')
      .then( ({data}) => {
        commit('setNews', data.map((item) => {
          return {
            title: item.Titre,
            url: item.Url,
            logo: `/gimc/strapi/${item.Logo.url}?width=200`,
            preview: `/gimc/strapi/${item.Apercu.url}?width=200`
          }
        }))
      })
      .catch( (err) => {
        console.log(err)
      })
    },
    async getSlide({commit}) {
      axios
      .get('https://strapi.hortusbox.com/before-afters?ShowIt_eq=true')
      .then( ({data}) => {
        commit('setSlide', data.map((item) => {
          return {
            name: item.ClientName,
            story: item.Description,
            after: "/gimc/strapi/"+item.PictAfter.url+"?height=550",
            before: "/gimc/strapi/"+item.PictBefore.url+"?height=550",
            avatar: "/gimc/strapi/"+item.Avatar.url,
            show: item.ShowIt
          }
        }))
      })
      .catch( (err) => {
        console.log(err)
      })
    },
    async getPartner({commit}) {
      axios
      .get('https://strapi.hortusbox.com/web-partners?ShowIt_eq=true')
      .then( ({data}) => {
        commit('setPartner', data.map((item) => {
          return {
            img: "/gimc/strapi/"+item.Logo.url,
            url: item.Url,
            show: item.ShowIt
          }
        }))
      })
      .catch( (err) => {
        console.log(err)
      })
    },
  },
  getters: {
    title: state => state.title,
    price: state => state.price,
    news: state => state.news,
    collabs: state => state.collabs,
    slides: state => state.slides,
    partners: state => state.partners,
    promoPrice: state => state.promoPrice,
    promoDeadline: state => state.promoDeadline,
    optinTitle: (state, getters, rootState, rootGetters) => {
      const host = rootGetters['app/host']
      return state.optinTitleByPartner[host] ? state.optinTitleByPartner[host] : state.optinTitleByPartner[constantes.HostHortusBox]
    },
    optinMsg: (state, getters, rootState, rootGetters) => {
      const host = rootGetters['app/host']
      return state.optinMsgByPartner[host] ? state.optinMsgByPartner[host] : state.optinMsgByPartner[constantes.HostHortusBox]
    },
    livrable: (state, getters, rootState, rootGetters) => {
      const host = rootGetters['app/host']
      return state.livrableByPartner[host] ? state.livrableByPartner[host] : state.livrableByPartner[constantes.HostHortusBox]
    }
  }
}
